import moment from 'moment';

const INGREDIENT_CHECKER_HIDDEN_CIDS = [
  '75980601-D77C-47DF-982B-7BBA3AD10D2A'
];

const INGREDIENT_CHECKER_TESTER_CIDS = [
  'BA4A53C0-BEDD-4CAC-A485-A3C08497B0C0',
  'D06C1B8D-80B9-49D3-B756-EA8E68B295A1',
  'A495433D-65E0-4EE2-8506-E27A7CDEB124',
  'C978D3BD-47C6-4FE9-93E5-482598A690E1',
];

export const ingredientCheckerSubscriptionEnabled = false;

function normalizeCid(cid) {
  return String(cid || '').trim().toUpperCase();
}

export function isIngredientCheckerTester(cid) {
  return INGREDIENT_CHECKER_TESTER_CIDS.includes(normalizeCid(cid));
}

export function canAccessIngredientChecker(cid) {
  return !INGREDIENT_CHECKER_HIDDEN_CIDS.includes(normalizeCid(cid));
}

export function isIngredientCheckerEnabledForCid(cid) {
  return ingredientCheckerSubscriptionEnabled || canAccessIngredientChecker(cid);
}

export const PASSWORD_ALLOWED_SPECIAL_CHARACTERS = '! @ # $ % ^ & * ( ) - + { } | : ; < > ? / \\\\';

export const PASSWORD_ALLOWED_CHARACTERS_TEXT = `Allowed characters: letters, numbers, and these special characters: ${PASSWORD_ALLOWED_SPECIAL_CHARACTERS}`;

export function validatePassword(password, confirmPassword) {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-+{}|:;<>?/\\])[A-Za-z\d!@#$%^&*()\-+{}|:;<>?/\\]{8,}$/;
  const isPasswordInvalid = !regex.test(password);
  const passwordMismatch = password !== confirmPassword ? 'Passwords do not match' : '';

  return {
    isPasswordInvalid,
    passwordMismatch
  };
}

export function checkAuthentication() {
  const token = localStorage.getItem('accessToken');
  this.isAuthenticated = !!token;
  if (this.isAuthenticated) {
    this.accessToken = token;
  }
}

/*
async logoutHandler() {
      try {
        await axios.post('/api/logout');
        localStorage.removeItem('isAuthenticated');
        this.isAuthenticated = false;
        this.$router.push('/login');
      } catch (error) {
        console.error('Logout failed:', error);
      }
    }
*/
// export function logout() {
//   localStorage.removeItem('accessToken');
//   localStorage.removeItem('cid');
//   this.isAuthenticated = false;
//   this.$router.push('/login');
// }

export function toggleVisibility(currentVisibility) {
  return !currentVisibility;
}

export function shouldHideIngredientChecker(cid) {
  return !canAccessIngredientChecker(cid);
}

export function convertUtcToLocal(utcDate) {
  return moment.utc(utcDate).local().format('MMM DD, YYYY hh:mm A');
}    

export function convertUtcToLocalDateOnly(utcDate) {
  return moment.utc(utcDate).local().format('MMMM DD, YYYY');
}    
